module.exports = {
          srcSet: __webpack_public_path__ + "28ee0ffdb8889558714952d6746bc5ff-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "28ee0ffdb8889558714952d6746bc5ff-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "28ee0ffdb8889558714952d6746bc5ff-120.png",
          toString:function(){return __webpack_public_path__ + "28ee0ffdb8889558714952d6746bc5ff-120.png"},
          
          width: 120,
          height: 120
        }